import Checkbox from "@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox";
import styles from "./UserAcknowledgement.module.scss";
import TermsAndConditionsAccordion from "../TermsAndConditionsAccordion/TermsAndConditionsAccordion";
import { ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE } from "../../constants/constants";

type Props = {
  /**
   * A string represting terms and condition text
   */
  terms: string;
};

export function UserAcknowledgementUI({ terms }: Props) {
  const sendEvent = (checked: boolean) => {
    const e = new CustomEvent(ADD_TO_BASKET_ESI_HIDDEN_OR_VISIBLE, {
      detail: {
        userAcknowledgementChecked: checked,
      },
    });
    window.dispatchEvent(e);
  };

  return (
    <div
      className={styles["user-acknowledege-container"]}
      data-test-id="user-acknolwedgment-container"
    >
      <Checkbox
        name="user-acknowledege-checkbox"
        className={styles["user-acknowledege-checkbox"]}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          sendEvent(event.target.checked);
        }}
        label={"I understand that I cannot return or exchange this item."}
      />
      <TermsAndConditionsAccordion terms={terms} />
    </div>
  );
}
